export const BikeAvailable = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <defs></defs>
    <path
      d="M15.25 8.273a3.476 3.476 0 1 0 6.952 0 3.476 3.476 0 1 0 -6.952 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.692 8.273a3.478 3.478 0 1 1 -1.533 -2.883"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.726 8.273 16.795 0.548l2.317 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m17.322 2.673 -5.711 0.696 -3.397 4.905 5.104 0L10.764 0.934l2.019 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.798 21.445 5.917 0.958a5.48 5.48 0 0 0 3.554 -0.717l6.195 -3.683a1.821 1.821 0 0 0 0.635 -2.502h0a1.821 1.821 0 0 0 -2.502 -0.636l-4.838 2.875"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.798 16.694 2.513 -1.494a5.472 5.472 0 0 1 3.083 -0.762l2.502 0.13a1.704 1.704 0 0 1 1.695 1.791h0A1.704 1.704 0 0 1 9.008 17.972l-3.194 -0.015"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const CarbonMonoxide = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.896 8.146a2.37 2.37 0 0 0 -1.491 0.535c0.031 -0.176 0.048 -0.355 0.054 -0.535a3.833 3.833 0 0 0 -7.59 -0.759A2.875 2.875 0 1 0 3.833 12.938h6.229"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.688 9.583h0.958a2.396 2.396 0 1 0 0 -4.792 2.37 2.37 0 0 0 -1.491 0.535c0.031 -0.176 0.048 -0.355 0.054 -0.535a3.833 3.833 0 0 0 -6.824 -2.396"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.743 11.324 9.008 19.13A1.917 1.917 0 0 0 10.642 22.042H20.125a1.917 1.917 0 0 0 1.638 -2.911l-4.739 -7.807a1.917 1.917 0 0 0 -3.28 0v0Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.382 13.896v3.011"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      d="M15.382 19.761a0.359 0.359 0 0 1 0 -0.719"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      d="M15.382 19.761a0.359 0.359 0 0 0 0 -0.719"
      strokeWidth="1"
    ></path>
  </svg>
);

export const CleaningService = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m18.688 3.833 3.833 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.208 1.917 21.563 0.479"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.208 5.75 3.354 1.438"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.188 1.438H13.417a0.479 0.479 0 0 1 0.479 0.479v3.833a0.479 0.479 0 0 1 -0.479 0.479H2.396l0 0v0a4.792 4.792 0 0 1 4.792 -4.792Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M6.229 6.229h3.833v3.833h-3.833z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.888 22.521H5.404A4.925 4.925 0 0 1 0.479 17.596h0a4.926 4.926 0 0 1 1.141 -3.153L4.983 10.408a0.958 0.958 0 0 1 0.736 -0.345h4.853a0.958 0.958 0 0 1 0.736 0.345l3.363 4.036a4.926 4.926 0 0 1 1.141 3.153h0a4.925 4.925 0 0 1 -4.925 4.925Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M13.417 9.104a2.875 2.875 0 0 1 -2.875 -2.875"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m15.813 2.396 0 2.875"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const CleaningServiceTwo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m19.885 4.073 -1.725 16.004c-0.096 0.958 -0.958 1.725 -1.917 1.725h-9.583c-0.958 0 -1.821 -0.767 -1.917 -1.725l-0.767 -4.121"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M10.063 1.198h10.302c1.054 0 1.917 0.863 1.917 1.917v0.958H9.583"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="m12.219 4.073 9.967 9.296"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M2.635 15.956h7.858s-1.917 -2.54 -1.917 -7.379c0 -4.84 1.917 -7.379 1.917 -7.379H3.59c-0.601 0 -1.166 0.284 -1.441 0.818C1.58 3.12 0.719 5.332 0.719 8.577c0 4.84 1.917 7.379 1.917 7.379Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M6.229 15.813s-1.917 -2.875 -1.438 -6.708"
      strokeWidth="1"
    ></path>
  </svg>
);

export const CoveredBike = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.479 18.688a3.833 3.833 0 1 0 7.667 0 3.833 3.833 0 1 0 -7.667 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M14.854 18.688a3.833 3.833 0 1 0 7.667 0 3.833 3.833 0 1 0 -7.667 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m10.542 18.688 5.447 -7.327L8.625 13.896l-3.593 3.992a0.479 0.479 0 0 0 0.356 0.8H10.542l-3.115 -7.667"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.688 18.688 -3.169 -8.603a0.479 0.479 0 0 1 0.333 -0.63L17.25 9.104"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m6.229 11.021 2.875 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m11.213 5.75 5.829 0.007a0.479 0.479 0 0 0 0.339 -0.14l0.895 -0.895a0.479 0.479 0 0 0 0.019 -0.657l-0.912 -1.028A0.479 0.479 0 0 0 17.027 2.875H11.213a3.833 3.833 0 1 0 0 2.875Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M6.229 4.313a1.438 1.438 0 1 0 2.875 0 1.438 1.438 0 1 0 -2.875 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const DoorLock = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.229 3.383v-1.917a0.958 0.958 0 0 1 0.958 -0.958h12.458a0.958 0.958 0 0 1 0.958 0.958v20.125a0.958 0.958 0 0 1 -0.958 0.958h-12.458a0.958 0.958 0 0 1 -0.958 -0.958v-2.875"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.021 15.841a0.958 0.958 0 0 1 -0.958 0.958h-6.708a0.958 0.958 0 0 1 -0.958 -0.958v-5.75a0.958 0.958 0 0 1 0.958 -0.958h6.708a0.958 0.958 0 0 1 0.958 0.958Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M5.508 13.027a1.198 1.198 0 1 0 2.396 0 1.198 1.198 0 1 0 -2.396 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M9.104 7.695a2.396 2.396 0 0 0 -4.792 0v1.438h4.792Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const DoubleBed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M2.396 11.021h18.208a0.958 0.958 0 0 1 0.958 0.958v3.833l0 0h-20.125l0 0v-3.833a0.958 0.958 0 0 1 0.958 -0.958Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M22.521 15.813V17.25a0.958 0.958 0 0 1 -0.958 0.958h-20.125a0.958 0.958 0 0 1 -0.958 -0.958v-1.438Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m1.438 18.208 0 1.917"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m21.563 18.208 0 1.917"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M2.396 11.021v-4.792a1.917 1.917 0 0 1 1.917 -1.917h14.375a1.917 1.917 0 0 1 1.917 1.917v4.792"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.5 10.063a0.958 0.958 0 0 1 -0.958 0.958H5.271a0.958 0.958 0 0 1 -0.958 -0.958v-0.795C4.313 7.954 7.159 7.667 7.906 7.667 8.347 7.667 11.5 7.964 11.5 9.267Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M18.688 10.063a0.958 0.958 0 0 1 -0.958 0.958H12.458a0.958 0.958 0 0 1 -0.958 -0.958v-0.795C11.5 7.954 14.375 7.667 15.094 7.667c0.441 0 3.594 0.297 3.594 1.6Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m2.396 6.229 0 -3.354"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m20.604 6.229 0 -3.354"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const FireExtinguisher = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.542 4.454V2.396H8.625v2.058A3.354 3.354 0 0 0 6.229 7.667v13.896a0.958 0.958 0 0 0 0.958 0.958h4.792a0.958 0.958 0 0 0 0.958 -0.958V7.667A3.354 3.354 0 0 0 10.542 4.454Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m4.313 0.479 4.313 1.917A5.271 5.271 0 0 0 3.354 7.667v11.979"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M19.103 0.484A0.479 0.479 0 0 1 19.646 0.958v2.875a0.479 0.479 0 0 1 -0.542 0.479l-5.813 -0.775A0.958 0.958 0 0 1 12.458 2.588v-0.379a0.958 0.958 0 0 1 0.832 -0.951Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m10.542 2.396 1.917 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M12.938 19.646H10.542a0.479 0.479 0 0 1 -0.479 -0.479V9.583a0.479 0.479 0 0 1 0.479 -0.479h2.396"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const FreeParking = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.313 20.604V22.042a0.479 0.479 0 0 1 -0.479 0.479H1.917a0.479 0.479 0 0 1 -0.479 -0.479v-1.438"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M17.729 20.604V22.042a0.479 0.479 0 0 1 -0.479 0.479h-1.917a0.479 0.479 0 0 1 -0.479 -0.479v-1.438"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.208 20.604a0.479 0.479 0 0 0 0.479 -0.479v-3.156a0.479 0.479 0 0 0 -0.14 -0.338L16.771 14.854h-14.375L0.619 16.631a0.479 0.479 0 0 0 -0.14 0.338V20.125a0.479 0.479 0 0 0 0.479 0.479Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M8.578 10.063H4.637a0.479 0.479 0 0 0 -0.446 0.301L2.396 14.854"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m0.479 18.688 4.313 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m14.375 18.688 4.313 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M10.063 6.708a6.229 6.229 0 1 0 12.458 0 6.229 6.229 0 1 0 -12.458 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M14.854 10.063v-6.708h1.917a1.917 1.917 0 0 1 0 3.833h-1.917"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const PaidParking = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.396 12.818h11.5a1.917 1.917 0 0 1 1.917 1.917v2.875a0.958 0.958 0 0 1 -0.958 0.958h-13.417a0.958 0.958 0 0 1 -0.958 -0.958v-2.875a1.917 1.917 0 0 1 1.917 -1.917Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m2.875 12.818 0.333 -3.034a1.917 1.917 0 0 1 1.911 -1.758h6.057a1.917 1.917 0 0 1 1.91 1.758L13.417 12.818"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M2.397 15.693a0.958 0.958 0 1 0 1.917 0 0.958 0.958 0 1 0 -1.917 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M11.98 15.693a0.958 0.958 0 1 0 1.917 0 0.958 0.958 0 1 0 -1.917 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M5.271 18.568v1.438a1.438 1.438 0 0 1 -2.875 0v-1.438"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M13.896 18.568v1.438a1.438 1.438 0 0 1 -2.875 0v-1.438"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M22.521 10.422a1.917 1.917 0 1 0 -3.833 0v11.021h3.833Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.687 10.901 7.786 1.557"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.687 14.255 3.822 -3.845"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.687 17.849 3.833 -3.83"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="m18.687 21.443 3.833 -3.833"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);

export const SmokeDetector = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <path
        d="M4.313 0.479A0.489 0.489 0 0 0 3.833 0.958v0.958a2.76 2.76 0 0 0 0.182 0.958l1.553 3.833a0.795 0.795 0 0 0 0.661 0.441h10.542a0.795 0.795 0 0 0 0.661 -0.441l1.553 -3.833A2.76 2.76 0 0 0 19.167 1.917V0.958a0.489 0.489 0 0 0 -0.479 -0.479Z"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m4.6 4.313 13.8 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m11.5 4.313 0 2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m14.854 4.313 -0.479 2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="m8.146 4.313 0.479 2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M16.292 7.188c0 1.323 -1.917 2.875 -4.792 2.875s-4.792 -1.553 -4.792 -2.875"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M7.322 12.938c-4.313 4.523 3.833 5.06 -0.45 9.583"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M11.73 12.938c-4.313 4.523 3.833 5.06 -0.46 9.583"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
      <path
        d="M16.129 12.938c-4.303 4.523 3.833 5.06 -0.45 9.583"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const Tv = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <g>
      <g>
        <path
          d="M2.396 5.271h18.208s1.917 0 1.917 1.917v13.417s0 1.917 -1.917 1.917h-18.208s-1.917 0 -1.917 -1.917v-13.417s0 -1.917 1.917 -1.917"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m19.646 8.146 0 7.667"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m4.313 0.479 4.792 4.792"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14.854 0.479 -4.792 4.792"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M6.229 7.188h6.708s3.833 0 3.833 3.833v5.75s0 3.833 -3.833 3.833h-6.708s-3.833 0 -3.833 -3.833v-5.75s0 -3.833 3.833 -3.833"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </g>
      <path
        d="M18.688 19.157a0.958 0.958 0 1 0 1.917 0 0.958 0.958 0 1 0 -1.917 0"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      ></path>
    </g>
  </svg>
);

export const WashingMachine = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
  >
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.677 20.365V2.635a1.917 1.917 0 0 1 1.917 -1.917h15.813a1.917 1.917 0 0 1 1.917 1.917v17.729a1.917 1.917 0 0 1 -1.917 1.917H3.594a1.917 1.917 0 0 1 -1.917 -1.917Z"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.552 3.594h2.875"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.677 6.469h19.646"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.708 14.375a4.792 4.792 0 1 0 9.583 0 4.792 4.792 0 1 0 -9.583 0"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.738 14.708a3.829 3.829 0 0 1 2.542 -0.944c1.589 0 4.449 2.655 6.99 0.14"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.458 3.833a0.24 0.24 0 1 1 0 -0.479"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.458 3.833a0.24 0.24 0 1 0 0 -0.479"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.771 3.833a0.24 0.24 0 1 1 0 -0.479"
      strokeWidth="1"
    ></path>
    <path
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.771 3.833a0.24 0.24 0 1 0 0 -0.479"
      strokeWidth="1"
    ></path>
  </svg>
);

export const Wifi = () => (
  <svg
    height="1.2em"
    width="1.2em"
    aria-hidden="true"
    viewBox="-0.5 -0.5 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.82 9.995a9.583 9.583 0 0 1 13.553 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M21.083 6.325a13.417 13.417 0 0 0 -18.975 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M7.53 13.663a5.75 5.75 0 0 1 8.132 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M18.373 9.995a9.583 9.583 0 0 0 -13.553 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M15.663 13.663a5.75 5.75 0 0 0 -8.132 0"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
    <path
      d="M9.679 18.688a1.917 1.917 0 1 0 3.833 0 1.917 1.917 0 1 0 -3.833 0Z"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    ></path>
  </svg>
);
